import { useCallback, useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { errMsg } from "../../../lib/portfolio";

export function usePortfolioProject(id) {
  const [project, setProject] = useState(null);
  const [media, setMedia] = useState([]);
  const [error, setError] = useState(null);
  const load = useCallback(async () => {
    try {
      const [p, m] = await Promise.all([
        api.get(`/admin/portfolio/projects/${id}`),
        api.get(`/admin/portfolio/projects/${id}/media`),
      ]);
      setProject(p.data);
      setMedia(m.data.items);
      setError(null);
    } catch (e) { setError(errMsg(e, "Could not load project.")); }
  }, [id]);
  useEffect(() => { load(); }, [load]);
  const pending = media.some((m) => ["uploaded", "processing"].includes(m.processing_state));
  useEffect(() => {
    if (!pending) return undefined;
    const t = setInterval(load, 3000);
    return () => clearInterval(t);
  }, [pending, load]);
  return { project, media, error, reload: load };
}
